import { Injectable, inject } from '@angular/core';


import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError } from 'rxjs/operators';

import * as fromStore from '../store';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NewsGuard  {
  private store = inject<Store<fromStore.ContentState>>(Store);


  canActivate(): Observable<boolean> {
    return this.checkStore().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkStore(): Observable<boolean> {
    return this.store.select(fromStore.getNewsLoaded).pipe(
      tap(loaded => {
        if (!loaded) {
          this.store.dispatch(fromStore.LoadNews({ profileId: 0, take: 3 }));
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
